import { createSelector, select } from '@ngrx/store';
import { filter, map, pipe, skipWhile } from 'rxjs';
import { AppState, PageControl } from '../lemans-app.model';

export const selectPageControlFeature = (state: AppState): PageControl => state.controlPage;
export const selectEulaState = createSelector(selectPageControlFeature, (state: PageControl) => state.isEulaAccepted);
export const selectUserFoundState = createSelector(selectPageControlFeature, (state: PageControl) => state.isUserFound);

export const isUserFound = pipe(
  select(selectUserFoundState),
  skipWhile((it) => it.isPending),
  filter((userFoundState) => userFoundState.isReady),
  map((userFoundState) => userFoundState.value),
);
/* eslint-disable @ngrx/prefix-selectors-with-select */
export const getApps = createSelector(selectPageControlFeature, (state: PageControl) => state.applications);
export const selectAppsMap = createSelector(selectPageControlFeature, (state: PageControl) => state.appsMap);
export const getEnabledApps = createSelector(
  selectPageControlFeature,
  (state: PageControl) => state.enabledApplications,
);
export const selectAppsDisplayNameMap = createSelector(selectPageControlFeature, (state: PageControl) =>
  Object.assign({}, ...state.applications.map((app) => ({ [app.appId]: app.appName }))),
);
export const isBaseURLSet = createSelector(selectPageControlFeature, (state: PageControl) => state.isBaseURLSet);
/* eslint-enable @ngrx/prefix-selectors-with-select */
export const selectEulaContent = createSelector(
  selectPageControlFeature,
  (state: PageControl) => state.eulaConfig?.eulaContent,
);
export const selectEulaConfig = createSelector(selectPageControlFeature, (state: PageControl) => state.eulaConfig);
export const selectApiError = createSelector(selectPageControlFeature, (state: PageControl) => state.apiError);
const selectCatalogInfo = createSelector(selectPageControlFeature, (state: PageControl) => state.catalogInfo);
export const selectVersions = createSelector(selectPageControlFeature, (state: PageControl) => state.versions);
export const selectIsUserActive = createSelector(selectPageControlFeature, (state: PageControl) => state.isUserActive);
export const catalogInfo = pipe(
  select(selectCatalogInfo),
  skipWhile((it) => it.isPending),
  map((it) => it.value),
);
export const mockableCatalogs = pipe(
  select(selectCatalogInfo),
  skipWhile((it) => it.isPending),
  map((it) => it.value.filter((pi) => pi.isMockAllowed)),
  map((data) => {
    data.sort((first, second) => first.name.trim().localeCompare(second.name.trim()));
    return data;
  }),
);
export const selectSessionTimedOut = createSelector(
  selectPageControlFeature,
  (state: PageControl) => state.sessionTimedOut,
);
export const selectExtendSession = createSelector(
  selectPageControlFeature,
  (state: PageControl) => state.extendSession,
);
export const selectLogoutSession = createSelector(
  selectPageControlFeature,
  (state: PageControl) => state.logoutSession,
);
export const selectHelpMenuToOpen = createSelector(
  selectPageControlFeature,
  (state: PageControl) => state.helpMenuToOpen,
);
export const selectLoggedInUserProfile = createSelector(
  selectPageControlFeature,
  (state: PageControl) => state.loggedInUserProfile,
);

export const selectRouteState = createSelector(selectPageControlFeature, (state: PageControl) => state.routeState);

export const selectGetCurrentRouteState = createSelector(
  (state) => state,
  (state: AppState) => state.routerState.state,
);
